import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewEncapsulation
} from '@angular/core'
import { Observable } from 'rxjs'
import { AvailableLangs, TranslocoService } from '@ngneat/transloco'
import { FuseNavigationService } from '@fuse/components/navigation'
import { UserService } from "app/core/user/user.service"
import {LangsListParamsService} from "@store/langs-list-params.service";

@Component({
    selector: 'languages',
    templateUrl: './languages.component.html',
    encapsulation: ViewEncapsulation.None,
    exportAs: 'languages',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LanguagesComponent implements OnInit
{
    // availableLangs: AvailableLangs;
    activeLang: string;
    flagCodes: any;

    langChange$: Observable<string>

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _fuseNavigationService: FuseNavigationService,
        private _translocoService: TranslocoService,
        private _userService: UserService,
        public langsListParamsService: LangsListParamsService,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.langChange$ = this._translocoService.langChanges$
        // this.availableLangs = this._translocoService.getAvailableLangs();

        // Set the country iso codes for languages for flags
        this.flagCodes = {
            'en': 'us',
            'fr': 'fr',

        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Set the active lang
     *
     * @param lang
     */
    setActiveLang(lang: string): void
    {
        this._translocoService.setActiveLang(lang);
        this._userService.changeLang(lang);
        // Forcer la détection de changement pour OnPush
        this._changeDetectorRef.markForCheck();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any
    {
        if (item == null) return index;
        return item.id ?? (typeof item === 'string' ? item : null) ?? index;
    }

    /**
     * Filter undefined/null and normalize items (Transloco can emit string[] or { id, label }[]).
     */
    filteredLangs(langs: ({ id: string; label: string } | string)[] | null | undefined): { id: string; label: string }[] {
        const list = langs ?? [];
        return list
            .filter((l): l is { id: string; label: string } | string => l != null)
            .map((l) => (typeof l === 'string' ? { id: l, label: l } : l));
    }
}
